import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthLayout from "./components/authLayout/main";
import Login from "./screens/login";
import ChangePassword from "./screens/changePassword";
import ResetPassword from "./screens/resetPassword";
import ForgotPassword from "./screens/forgotPassword";
import SignUp from "./screens/signUp";
import DashboardLayout from "./components/dashboardLayout/main";
import ActivityHistory from "./screens/activityHistory";
import Profile from "./screens/profile";
import PaymentHistory from "./screens/paymentHistory";
import Transcript from "./screens/transcript";
import PaymentDetails from "./screens/paymentDetails";
import PaymentResponse from "./screens/paymentResponse";
import ProtectedRoute from "./utils/protectedRoute";
import Clearance from "./screens/clearance";
import Verification from "./screens/requestVerification";
import VerificationLayout from "./components/verificationLayout/main";
import VerificationSuccess from "./screens/verificationSuccess";

function App() {
  return (
    <Router>
      <Routes>
        {/* Auth Routes */}
        <Route
          path="/"
          element={
            <AuthLayout>
              <Login />
            </AuthLayout>
          }
        />
        <Route
          path="/change-password"
          element={
            <AuthLayout>
              <ChangePassword />
            </AuthLayout>
          }
        />
        <Route
          path="/reset-password"
          element={
            <AuthLayout>
              <ResetPassword />
            </AuthLayout>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <AuthLayout>
              <ForgotPassword />
            </AuthLayout>
          }
        />
        <Route
          path="/sign-up"
          element={
            <AuthLayout>
              <SignUp />
            </AuthLayout>
          }
        />

        {/* Protected Dashboard Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/activity-history" element={<ActivityHistory />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/payment-history" element={<PaymentHistory />} />
            <Route path="/transcript" element={<Transcript />} />
            <Route
              path="/transcript-payment-details"
              element={<PaymentDetails />}
            />
            <Route path="/payment-success" element={<PaymentResponse />} />
            <Route path="/clearance" element={<Clearance />} />
          </Route>
        </Route>

        <Route
          path="/verify"
          element={
            <VerificationLayout>
              <Verification />
            </VerificationLayout>
          }
        />
        <Route
          path="/verification-success"
          element={
            <VerificationLayout>
              <VerificationSuccess />
            </VerificationLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
